(function () {
  function computeState(count) {
    if (count === 1) return { pct: 50, text: 'Agrega otro producto y obtén <strong>15% de descuento</strong>' };
    if (count === 2) return { pct: 80, text: '<strong>¡15% de descuento aplicado!</strong> Agrega tu tercer producto y obtén 25%' };
    return { pct: 100, text: '<strong>¡25% de descuento aplicado!</strong> en tu compra' };
  }

  function getDismissed() {
    try { return sessionStorage.getItem('dpbDismissedCount'); } catch (e) { return null; }
  }

  function setDismissed(count) {
    try { sessionStorage.setItem('dpbDismissedCount', count); } catch (e) {}
  }

  function clearDismissed() {
    try { sessionStorage.removeItem('dpbDismissedCount'); } catch (e) {}
  }

  var lastRenderedCount = null;

  // Cuenta solo piezas "reales": excluye cualquier línea del carrito cuyo
  // precio final haya quedado en $0 (regalos por umbral, tipo el anillo/
  // collar de regalo). Así, si mañana cambia el producto de regalo, esto
  // sigue funcionando sin tocar código: cualquier línea gratis se ignora.
  function realItemCount(cart) {
    var items = (cart && cart.items) || [];
    var count = 0;
    for (var i = 0; i < items.length; i++) {
      var item = items[i] || {};
      var isFree = item.final_line_price === 0 || item.final_price === 0;
      if (!isFree) count += item.quantity || 0;
    }
    return count;
  }

  function render(count) {
    var bar = document.getElementById('discount-progress-bar');
    if (!bar) return;

    lastRenderedCount = count;

    if (count <= 0) {
      clearDismissed();
      bar.hidden = true;
      bar.setAttribute('data-item-count', 0);
      return;
    }

    var dismissedCount = getDismissed();
    if (dismissedCount !== null && parseInt(dismissedCount, 10) === count) {
      bar.hidden = true;
      bar.setAttribute('data-item-count', count);
      return;
    }

    var state = computeState(count);
    var textEl = bar.querySelector('.discount-progress-bar__text');
    var meterEl = bar.querySelector('.dpb-meter');
    if (textEl) textEl.innerHTML = state.text;
    if (meterEl) meterEl.style.width = state.pct + '%';
    bar.hidden = false;
    bar.setAttribute('data-item-count', count);
  }

  function refreshFromCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = realItemCount(cart);
        if (count !== lastRenderedCount) {
          render(count);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('discount-progress-bar');
    if (!bar) return;

    var currentCount = parseInt(bar.getAttribute('data-item-count'), 10) || 0;
    lastRenderedCount = currentCount;
    if (currentCount <= 0) {
      clearDismissed();
    }

    var closeBtn = bar.querySelector('.discount-progress-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        var count = parseInt(bar.getAttribute('data-item-count'), 10) || 0;
        setDismissed(count);
        bar.hidden = true;
      });
    }

    // Camino principal: eventos nativos de Dawn (agregar/quitar vía el tema).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshFromCart();
      });
    }

    // Respaldo: algunas apps de carrito (ej. Rebuy) modifican el carrito
    // por su cuenta sin avisarle a Dawn. Este sondeo detecta esos cambios
    // igual, revisando el carrito real cada pocos segundos.
    setInterval(refreshFromCart, 2500);

    // Respaldo adicional: revisar tambien cuando la pestana vuelve a estar
    // visible (usuario regresa de otra pestana/app) y al hacer click en
    // cualquier parte de la pagina (cubre clicks dentro de widgets de
    // carrito de terceros que no burbujean eventos estandar).
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshFromCart();
    });
    document.addEventListener('click', function () {
      setTimeout(refreshFromCart, 600);
    });
  });
})();
